// @unocss-include
const layout = () => import('@/layout/index.vue')
const routes = [
  {
    path: '/orderManage',
    name: 'OrderManage',
    component: layout,
    redirect: '/orderManage/orderList',
    meta: {
      title: '订单管理',
      icon: 'i-tabler:file-invoice',
      roles: [0]
    },
    sort: 7,
    children: [
      {
        path: 'orderList',
        name: 'OrderList',
        component: () => import('@/views/Manage/Order/OrderList/Index.vue'),
        meta: {
          title: '订单列表',
          icon: 'i-tabler:menu-order',
          roles: [0]
        }
      },
      {
        path: 'invoice',
        name: 'Invoice',
        component: () => import('@/views/Manage/Order/Invoice/Index.vue'),
        meta: {
          title: '发票管理',
          icon: 'i-tabler:receipt',
          roles: [0]
        }
      }
    ]
  }
]
export default routes
